import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ConnectedDeviceService } from '../services';

@Component({
  selector: 'sysman-connected',
  templateUrl: './sysman-connected.component.html'
})
export class SysmanConnectedComponent implements OnInit {

  @Input() uuid: string;
  @Input() ip: string;
  @Input() uptime: number;
  @Input() version: string;
  @Input() directorName: string;
  @Input() showHomeLink: boolean;
  @Input() isUpdateAvailable?: boolean;

  constructor(private router: Router, private route: ActivatedRoute, 
              private connectedDeviceService: ConnectedDeviceService) {
  }

  ngOnInit() {
  }

  goDiscoveryPage() {
    this.router.navigate(["../../sysman/disco"], { relativeTo: this.route });
  }

  goUpdateDevice() {
    // TBD - for first release of sysman this link may not exist
    //this.router.navigate(["/config/update/simple"], { relativeTo: this.route });
  }

  getType(uuid: string): string {
    if (uuid) {
      if ((uuid.indexOf("home-controller") > -1) || (uuid.indexOf("ea") == 0))
        return "Controller";
      else
        if (uuid.indexOf("glassedge") > -1)
          return "Glass Edge Touch Screen";
        else
        if (uuid.indexOf("bcm-") > -1)
          return "Touch Screen";
        else
        if (uuid.indexOf("touchpanel-") > -1)
          return "Touch Panel";
        else
          if (uuid.indexOf("xtender") > -1)
            return "IO Extender";
          else
          if (uuid.indexOf("sony-avr") > -1)
            return uuid;
          else
          if (uuid.charAt(3) == '-') // c4 device
            return uuid.substring(3, uuid.length - 13);
          else // other, or custom device
            return uuid;
    }
    else
      return "";
  }
}



// WEBPACK FOOTER //
// ./~/@c4/sysman/src/app/sysman-connected/sysman-connected.component.ts